import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { SpaceHeaderTestIds } from '~src/spacesPlatform/components/header/SpaceHeader';
import { SpaceHeaderStyles } from '~src/spacesPlatform/components/header/SpaceHeaderStyles';
import { ITaggedItemInfo } from '~src/spacesPlatform/models/resourceInfoParts';
import { cssClass } from '~src/style';

const cssPrefix = 'TagsMetadata';

const separator = cssClass(cssPrefix, 'separator', {
  marginRight: CommonStyles.Sizes.SmallSpace
});

const noTags = cssClass(cssPrefix, 'noTags', {
  fontStyle: 'italic'
});

const renderTags = (tags: string[], tagUrl: (tag: string) => string): JSX.Element[] | JSX.Element => {
  const tagLinks: JSX.Element[] = tags?.reduce((acc, tag, i) => {
    acc.push(<a href={tagUrl(tag)} title={tag} key={tag}>{tag}</a>);
    if (i < tags.length - 1) {
      acc.push(<span className={separator} key={tag + 'separator'}>,</span>);
    }
    return acc;
  }, []);

  return tags?.length > 0 ? tagLinks : <span className={noTags}>{Messages.noTagsAvailable()}</span>;
};

export type TagsMetadataProps = {
  itemInfo: ITaggedItemInfo;
  tagUrl: (tag: string) => string;
}

export function TagsMetadata(props: TagsMetadataProps): JSX.Element {
  const { itemInfo, tagUrl} = props;

  return <React.Fragment>
    <span className={SpaceHeaderStyles.TextLabelWithNoLeftMargin}>
      {Messages.tags()}
    </span>
    <span className={SpaceHeaderStyles.MetadataInfo} data-tb-test-id={SpaceHeaderTestIds.tags}>
      {renderTags(itemInfo.tags, tagUrl)}
    </span>
  </React.Fragment>;
}
